import type { To } from 'react-router-dom';
import { useNavigation } from 'react-router-dom';

import type { Props } from '../LoadingButton';
import { LoadingButton } from '../LoadingButton';

export const NavigatingButton = ({
  to,
  ...props
}: Omit<Props, 'loading'> & { to: To }) => {
  const navigation = useNavigation();

  return (
    <LoadingButton
      to={to}
      {...props}
      loading={navigation.location?.pathname === to}
    />
  );
};
